import { DateTime } from 'luxon';
import { z } from 'zod';

export const sqlDateTimeParser = z.object({
	date: z.string(),
	timezone_type: z.union([z.literal(1), z.literal(2), z.literal(3)]),
	timezone: z.string(),
});
export type SQLDateTime = z.infer<typeof sqlDateTimeParser>;

export const transformSQLDateTime = (sqlDateTime: SQLDateTime): Date => {
	switch (sqlDateTime.timezone_type) {
		// offset
		case 1:
		// short code
		case 2:
			return new Date(`${sqlDateTime.date} ${sqlDateTime.timezone}`);
		// timezone identifier
		case 3:
			return DateTime.fromSQL(sqlDateTime.date, {
				zone: sqlDateTime.timezone,
			}).toJSDate();
			break;
	}
	return new Date();
};

export const phpDateString = (date: Date) => {
	return DateTime.fromJSDate(date).toFormat("yyyy-MM-dd'T'HH:mm:ssZZZ");
};
